import { effect, signal } from "alien-signals";

const THEME_KEY = "theme";

// Theme signal initialized from localStorage
export const themeSignal = signal<string>(localStorage.getItem(THEME_KEY) || "light");

// Toggle function
export function toggleTheme() {
  themeSignal(themeSignal() === "light" ? "dark" : "light");
}

// Effect: persist to localStorage and update DOM
effect(() => {
  const theme = themeSignal();
  localStorage.setItem(THEME_KEY, theme);
  document.documentElement.setAttribute("data-theme", theme);
});
